import presets from "../../../config/catalogue-fact-presets.json";

/** Optional definition templates. Values always come from verified product data. */
export const PRODUCT_FACT_PRESETS = presets.map((preset) => ({
  ...preset,
  type: preset.type as "NUMBER" | "ENUM" | "TEXT",
}));

/** Explicit measurement conversion; never guess the unit of an existing value. */
export function measurementInMillimetres(value: number, unit: "mm" | "cm" | "in"): number {
  if (!Number.isFinite(value) || value <= 0) throw new Error("Enter a positive measurement with a known unit.");
  const converted = value * (unit === "in" ? 25.4 : unit === "cm" ? 10 : 1);
  if (converted > 1_000_000) throw new Error("Measurement is outside the supported range.");
  return Math.round(converted * 1000) / 1000;
}

/** A suggestion only: generic labels cannot be safely converted into a colour. */
export function attributeNormalizationSuggestion(value: string): { value: string; needsReview: boolean; reason: string | null } {
  const normalized = value.trim().replace(/\s+/g, " ");
  const generic = ["colour", "color", "greyscale", "grayscale", "unknown", "other"].includes(normalized.toLowerCase());
  return { value: normalized, needsReview: generic || normalized !== value, reason: generic ? "This label does not identify a specific product fact. Verify it against the item before changing it." : normalized !== value ? "Whitespace differs; check for an existing value before combining labels." : null };
}
